import LogoutButton from "./LogoutButton";
import React from "react";
import getDisplayNameSelector from "../../../state/selectors/ClientSelectors/getDisplayNameSelector";
import styled from "styled-components";
import { useSelector } from "react-redux";

const LoggedUser: React.FC = () => {
    const displayName = useSelector((state: Store) => getDisplayNameSelector(state));
    return (
        <Container>
            <UserContainer>{displayName}</UserContainer>
            <LogoutButton />
        </Container>
    );
};

export default LoggedUser;

const Container = styled.div``;
const UserContainer = styled.span`
    padding: 0 1rem;
    display: inline-flex;
    justify-content: flex-end;
`;
